module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Pictures#2-54b6bd3d51029c0b27fc892bcab77aa6.svg";